import { connect } from 'react-redux';
import {
  workingDetailingGetListCommits,
  workingDetailingGetListPhotos,
  workingDetailingAddCommit,
  workingDetailingAddPhoto,
  workingDetailingSendEmail,
  workingDetailingDelCommit,
  workingDetailingDelPhoto
} from '../../../store/actions/workingDetailing';
import { userGetPermissions } from '../../../store/actions/user';
import {
  getDecision,
  getDecisionsList,
  setHoldOn,
  saveDecision,
  declineDecision,
  acceptDecision
} from '../../../store/actions/decision';
import WorkingDetailing from './WorkingDetailing';
import { modalAddCommentOpen, modalOnHoldOpen } from '../../../store/actions/modal';

const mapStateToProps = ({
  workingDetailingReducer,
  pieceInfoReducer,
  userReducer,
  decisionReducer,
  modalReducer
}) => ({
  workingDetailingReducer,
  pieceInfoReducer,
  userReducer,
  decisionReducer,
  modalReducer
});
const mapDispatchToProps = {
  workingDetailingGetListCommits,
  workingDetailingGetListPhotos,
  workingDetailingAddCommit,
  workingDetailingAddPhoto,
  workingDetailingSendEmail,
  workingDetailingDelCommit,
  workingDetailingDelPhoto,
  userGetPermissions,
  getDecision,
  getDecisionsList,
  setHoldOn,
  saveDecision,
  declineDecision,
  acceptDecision,
  modalAddCommentOpen,
  modalOnHoldOpen
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WorkingDetailing);
